"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPendingSymbolResponseData = exports.getSymbolActivityList = exports.getSymbolPendingList = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
__exportStar(require("./interface"), exports);
const getLApiURL = () => {
    const lApi = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().lApi;
    if (!lApi) {
        console.info(`lApi值为 ${lApi}， 请在检查 runTimeHost 设置`);
    }
    return lApi;
};
/**
 * 获取未上架资产
 * https://pionex.atlassian.net/wiki/spaces/backend/pages/493519075/API#%E6%9C%AA%E4%B8%8A%E6%9E%B6%E8%B5%84%E4%BA%A7%E5%88%97%E8%A1%A8
 */
function getSymbolPendingList() {
    return trade_utils_lib_1.Network.get({
        url: `${getLApiURL()}/symbol_pending_list`,
    });
}
exports.getSymbolPendingList = getSymbolPendingList;
/**
 * 新资产活动
 * https://pionex.atlassian.net/wiki/spaces/backend/pages/493519075/API#%E6%9C%AA%E4%B8%8A%E6%9E%B6%E8%B5%84%E4%BA%A7%E5%88%97%E8%A1%A8
 */
function getSymbolActivityList(base, quote) {
    return trade_utils_lib_1.Network.get({
        url: `${getLApiURL()}/symbol_activity_list`,
        data: { base, quote },
    });
}
exports.getSymbolActivityList = getSymbolActivityList;
/**
 * 新资产介绍
 * https://pionex.atlassian.net/wiki/spaces/backend/pages/493519075/API#%E6%96%B0%E8%B5%84%E4%BA%A7%E4%BF%A1%E6%81%AF
 */
function getPendingSymbolResponseData(base, quote) {
    return trade_utils_lib_1.Network.get({
        url: `${getLApiURL()}/symbol`,
        data: { base, quote },
    });
}
exports.getPendingSymbolResponseData = getPendingSymbolResponseData;
